import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Drawer } from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import "../manifest_verificationqueue/verification-slider.css";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import CommonObj from "../../CommonObj";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";

const LangSliderUI = (props) => {
	console.log(props.selectedRecord);

	const [form, setForm] = useState({
		languageCode: "",
		languageName: "",
		status: "",
	});
	const { roleUserId } = useAuth();
	const { accessToken } = useAuthToken();
	const [loading, setLoading] = useState(false);
	const [errors] = useState({}); // Kept minimal to prevent ReferenceError in JSX
	const [ierrors, setIErrors] = useState({});
	const [selectedStatus, setSelectedStatus] = useState();
	const [masterData, setMasterData] = useState({
		language: [],
	});
	const fetchUserData = async (userId) => {
		setLoading(true);
		const requestData = {
			LanguageId: userId,
			UserId: roleUserId,
		};

		let formData = new FormData();
		Object.keys(requestData).forEach(function (key) {
			formData.append(key, requestData[key]);
		});

		try {
			const myHeaders = {
				Authorization: `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp()
			};
			const response = await fetch(CommonObj.Endpoints.GetLanguageById, {
				method: "POST",
				headers: myHeaders,
				body: formData,
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			const responseText = await response.text();
			let result;

			try {
				result = JSON.parse(responseText);
				setForm({
					languageCode: result.languageCode || "",
					languageName: result.languageName || "",
					status: result.status || "",
				});
				props.setSelectedLang(result.languageName || "")
				setSelectedStatus(result.status);
			} catch (e) {
				if (!responseText.includes("No books found.")) {
					throw new Error(responseText || "Failed to parse API response.");
				}
			}
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		const fetchMasterData = async () => {
			try {
				const response = await fetch(CommonObj.Endpoints.GetMasterData, {
					method: "GET",
					mode: "cors",
					headers: {
						Authorization: `Bearer ${accessToken}`,
						"X-CSRF-Token": encryptTimestamp(),
						"Content-Type": "application/json",
					},
				});


				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				const data = await response.json();
				setMasterData(data);
			} catch (error) {
				console.error("Failed to fetch master data:", error);
			}
		};

		fetchMasterData();
	}, []);
	useEffect(() => {
		if (!props.selectedRecord && props.visible) {
			setForm({
				languageCode: "",
				languageName: "",
				status: "",
			});
			setSelectedStatus(true);
		}
	}, [props.visible, props.selectedRecord]);

	useEffect(() => {
		if (props.selectedRecord && props.visible) {
			fetchUserData(props?.selectedRecord.languageId);
		}
	}, [props.selectedRecord, props.visible]);

	const handleInternalSubmit = async (e) => {
		e.preventDefault();
		setIErrors({});

		if (!i_validate()) {
			const firstErrorField = Object.keys(ierrors)[0];
			if (firstErrorField) {
				const element = document.getElementById(firstErrorField);
				if (element) element.focus();
			}
			return;
		}
		setLoading(true);
		try {
			const isEdit = !!props.selectedRecord;

			const myHeaders = {
				Authorization: `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp()
			};

			const payload = isEdit
				? {
					languageCode: form.languageCode,
					languageName: form.languageName,
					languageId: props.selectedRecord.languageId,
					Status: selectedStatus ? 1 : 0,
					UserId: roleUserId,
				}
				: {
					languageCode: form.languageCode,
					languageName: form.languageName,
					UserId: roleUserId,
				};

			let formData = new FormData();
			Object.entries(payload).forEach(([key, value]) => {
				formData.append(key, value);
			});

			const endpoint = isEdit
				? CommonObj.Endpoints.UpdateLanguage
				: CommonObj.Endpoints.CreateLanguage;

			const response = await fetch(endpoint, {
				method: "POST",
				headers: myHeaders,
				body: formData,
			});

			if (!response.ok) throw new Error(`Response status: ${response.status}`);

			const result = await response.json();
			if (result.status === false) {
				const ErrorMsg = result.message !== "" ? result.message : "Failed to save the data";
				message.error(ErrorMsg);
				return;
			}

			if (result.id == "0") {
				const ErrorMsg = "Language already exists.";
				message.error(ErrorMsg);
				return;
			}

			if (result) {
				const successMsg = isEdit
					? "Language updated successfully."
					: "Language created successfully.";

				message.success(successMsg);
				handleClear();
				props.onClose();

				if (props.onSuccess) {
					props.onSuccess();
				}
			} else {
				const msg =
					result.message != "" ? result.message : "Failed to save the data";
				message.error(msg);
			}
		} catch (error) {
			message.error("Error submitting form: " + error.message);
		} finally {
			setLoading(false);
		}
	};

	const handleClear = () => {
		setForm({
			languageCode: "",
			languageName: "",
			status: "",
		});
		props.setSelectedLang("")
		setSelectedStatus(true);
		setIErrors({});
	};
	const handleLanguageChange = (e) => {
		const { name, value } = e.target;
		if (ierrors[name]) {
			setIErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[name];
				return newErrors;
			});
		}

		props.setSelectedLang(value);
		setForm((prev) => ({
			...prev,
			[name]: value
		}));
	};
	const i_validate = () => {
		const newErrors = {};
		if (!form.languageCode || !form.languageCode.trim()) {
			newErrors.languageCode = "Please enter Language Code";
		}
		if (!form.languageName ) {
			newErrors.languageName = "Please enter Language Name";
		}

		setIErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleInternalChange = (e) => {
		const { name, value } = e.target;
		setForm((prev) => ({ ...prev, [name]: value }));
		if (ierrors[name]) {
			setIErrors((prev) => ({ ...prev, [name]: "" }));
		}
	};

	const handlestatusChange = (e) => {
		setSelectedStatus(e.target.checked);
	};

	useEffect(() => {
		if (props.selectedRecord) {
			message.info(props.selectedRecord);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleClose = () => {
		setIErrors({});
		props.onClose();
	};

	return (
		<Drawer
			title={props.selectedRecord ? "Edit Language" : props.title}
			placement={props.placement}
			onClose={handleClose}
			open={props.visible}
			width={props.width}
			className={props.className}
			closeIcon={<CloseCircleOutlined />}
			loading={loading}
		>
			<div className="modal-body">
				<div className="">
					<form
						className="book-page-form"
						onSubmit={handleInternalSubmit}
						noValidate
					>
						<div className="add-user-internal-container">
							<div className="add-user-internal-input-2column">
								<div className="field-group">
									<input
										placeholder=""
										id="languageCode"
										name="languageCode"
										value={form.languageCode}
										className={`book-page-form-input-text ${form?.languageCode === "" ? "" : "has-text"}`}
										maxLength={100}
										onChange={(e) => {
											const value = e.target.value;
											const filteredValue = value.replace(/[^a-zA-Z0-9 -]/g, '');
											handleInternalChange({ target: { name: 'languageCode', value: filteredValue } });
										}}
										required
									/>
									<label htmlFor="languageCode" className="label">
										Enter Language Code <span className="form-required">*</span>
									</label>
									{ierrors.languageCode && (
										<span className="error-msg">
											{ierrors.languageCode}
										</span>
									)}
								</div>
								{/* {!props.selectedRecord ? 	 */}
								<div className="field-group">
									<input
										id="languageName"
										name="languageName"
										className={`book-page-form-input-text ${form?.languageName === "" ? "" : "has-text"}`}
										maxLength={100}
										value={form.languageName}
										onChange={(e) => {
											const value = e.target.value;
											const filteredValue = value.replace(/[^a-zA-Z0-9 ]/g, '');
											handleInternalChange({ target: { name: 'languageName', value: filteredValue } });
										}}
										required
									/>
									<label htmlFor="languageName" className="label">
										Enter Language Name <span className="form-required">*</span>
									</label>
									{ierrors.languageName && (
										<span className="error-msg">{ierrors.languageName}</span>
									)}
								</div>
								{/* : 								<div className="field-group">
										<select
											id="languageName"
											name="languageName"
											className={`book-page-form-input-text ${form?.languageName === "" ? "" : "has-text"}`}
											value={props.selectedLang}
											onChange={handleLanguageChange}
											required
										>
											<option value="" disabled hidden>

											</option>
											{masterData.language.map((language) => {
												return (
													<option
														key={language.languageName}
														value={language.languageName}
														disabled={language.status == "0" }
													>
														{language.languageName}
													</option>
												);
											})}
										</select>

									<label htmlFor="language" className="label">
										Language <span className="form-required">*</span>
									</label>
									{ierrors.languageName && (
										<span className="error-msg">{ierrors.languageName}</span>
									)}

								</div>} */}
							</div>
							{props?.selectedRecord && (
								<div className="book-page-form-checkbox-button">
									<input
										type="checkbox"
										id="status"
										name="status"
										data-track="language-master-edit-is-active-toggle"
										onChange={handlestatusChange}
										checked={selectedStatus || undefined}
									/>
									<label htmlFor="status">
										Is Active
									</label>
									<span className="error-msg">{errors.status}</span>
								</div>
							)}
						</div>
						<div className="modal-footer">
							<button type="button" className="modal-cancel-button" onClick={handleClear}>
								Clear
							</button>
							<button className="accept-button" data-track="language-master-submit-language">Submit</button>
						</div>
					</form>
				</div>
			</div>
		</Drawer>
	);
};

LangSliderUI.propTypes = {
	selectedRecord: PropTypes.shape({
		languageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}),
	visible: PropTypes.bool,
	title: PropTypes.string,
	placement: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	className: PropTypes.string,
	onSuccess: PropTypes.func,
};

export default LangSliderUI;

